<section class="flex-column full-height bms-theme-content">
  @if (canShowHeader) {
    <vdw-dialog-header
      [title]="navigationHelper.getHeaderText(pageType, STOCK_LOCATION_TRANSLATION_KEY) + createdObject"
      [isLocked]="isLocked()"
      [lockIconConfig]="lockIconConfig"
      (backEvent)="navigationHelper.navigateBack()"
    />
  }

  <vdw-editor-header
    [identifier]="HEADER_IDENTIFIER"
    [menuItems]="[selectedMenuItem]"
    [extraPadding]="!canShowHeader"
    [selectedMenuItem]="selectedMenuItem"
    [isCreateNewPage]="pageType !== 'Edit'"
    [canShowSettings]="false"
    [canShowDelete]="false"
    [canShowDuplicate]="false"
    [canShowSave]="false"
    [inProgress]="saving"
    [disableSaveButton]="isLocked()"
    (cancelEvent)="navigationHelper.navigateBack()"
    (saveEvent)="save(SAVE_TYPE.SAVE)"
    (saveAndCreateNewEvent)="save(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
    (saveAndCloseEvent)="save(SAVE_TYPE.SAVE_AND_CLOSE)"
    (selectedMenuItemChange)="selectedMenuItem = $event"
  ></vdw-editor-header>

  <div class="bms-theme flex-column p-48">
    <form [formGroup]="addStockLocationForm" class="flex-column" vdwBp.gt-sm="pr-64 half-width" vdwBp.lt-sm="full-width" appBreadcrumbFormLinker>
      <vdw-string-input
        [label]="'GENERAL.NAME' | bmsTranslate"
        formControlName="name"
        [placeholder]="'GENERAL.NAME_PLACEHOLDER' | bmsTranslate: {object: STOCK_LOCATION_TRANSLATION_KEY | bmsTranslate: {count: 1} | lowercase}"
      >
        <ng-container error>
          <vdw-invalid-form-message *vdwCanShowErrorForFormControl="'name'; error: 'required'" [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
          <vdw-invalid-form-message
            *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'"
            [message]="'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate"
            [loadEntry]="getLoadEntry()"
            [compact]="true"
          ></vdw-invalid-form-message>
        </ng-container>
      </vdw-string-input>
    </form>
  </div>
</section>
